
import "slick-carousel";
import "bootstrap";

import './scripts/jquery';

import { initializeSlider } from './scripts/initializeSlider';
import { stickyHeader } from './scripts/stickyHeader';


initializeSlider();
stickyHeader();

(() => {
    const PUMBLE_SEO_EVENTS_USER = "pumble-seo-events-user";
    const PUMBLE_SEO_EVENTS_PAGE_URL = "pumble-seo-events-page-url";
    const PUMBLE_SEO_EVENTS_VISIT_TIMESTAMP = "pumble-seo-events-visit-timestamp";

    const getPumbleSeoEventsUser = () => localStorage.getItem(PUMBLE_SEO_EVENTS_USER)
    const setPumbleSeoEventsUser = (user) => localStorage.setItem(PUMBLE_SEO_EVENTS_USER, user)
    const setPumbleSeoEventsPageUrl = (pageUrl) => localStorage.setItem(PUMBLE_SEO_EVENTS_PAGE_URL, pageUrl)
    const setPumbleSeoEventsVisitTimestamp = (timestamp) => localStorage.setItem(PUMBLE_SEO_EVENTS_VISIT_TIMESTAMP, `${timestamp}`)

    const makeSEOEventPostRequest = (data, keepAlive = false) => {
        fetch("https://api-ga.pumble.com/porcos/events/seo-events", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
            keepalive: keepAlive,
        })
            .then((response) => response)
            .catch((error) => console.error("Error: ", error));
    };

    const loadData = () => {
        if (!getPumbleSeoEventsUser()) {
            const analyticsUserId =
                Date.now().toString(36) + Math.random().toString(36).substring(2);
            setPumbleSeoEventsUser(analyticsUserId);
        }
        setPumbleSeoEventsPageUrl(window.location.href)
        setPumbleSeoEventsVisitTimestamp(Date.now())
    };

    const sendVisitRequest = () => {
        const visitAnalyticsBody = {
            event: "visit",
            userId: getPumbleSeoEventsUser(),
            pageUrl: window.location.href,
        };

        makeSEOEventPostRequest(visitAnalyticsBody);
    };

    const handleLinkClick = (event) => {
        const targetElementAnchor = event.target.closest("a");

        if (targetElementAnchor) {
            let section = targetElementAnchor.textContent.trim();
            let clickAnalyticsBody = {
                event: "click",
                userId: getPumbleSeoEventsUser(),
                pageUrl: window.location.href,
                section: section,
            };

            makeSEOEventPostRequest(clickAnalyticsBody, true);
        }
    };

    document.addEventListener("DOMContentLoaded", () => {
        loadData();
        sendVisitRequest();
    });
    document.addEventListener("click", handleLinkClick);
})();